import React from "react";

import { useTranslation } from "react-i18next";

import { Port } from "../../../../../../../models/port";
import { ActionButtonProps } from "../../../../../../../components/Generic/ActionButtons";
import Modal from "../../../../../../../components/Generic/Modal";
import General from "./General";
import useStyles from "./styles";

interface Props {
  port?: Port;
  isOnViewMode?: boolean;
  hasErrors?: boolean;
  open: boolean;
  isLoading?: boolean;
  closeModal: () => void;
}

const PortModal = ({ port, open, isLoading = false, isOnViewMode = false, closeModal }: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const handleSetModalTitle = (): string => {
    if (port) {
      if (isOnViewMode) return translate("viewPort");

      return translate("editPort");
    }

    return translate("createANewPort");
  };

  const actionButtonProps: ActionButtonProps = {
    dataCySave: "submitButton",

    loading: isLoading,
  };

  return (
    <Modal
      data-cy="portModal"
      open={open}
      handleClose={closeModal}
      title={handleSetModalTitle()}
      showActionButtons
      actionButtonProps={actionButtonProps}
      labelStatus={translate("status")}
      bodyClassName={!port ? classes.modalSection : ""}
      showModalBodyScroll={!port}
    >
      <div className={classes.paperBody}>
        <General isOnViewMode={isOnViewMode} port={port} />
      </div>
    </Modal>
  );
};

export default PortModal;
